import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';

const Separator: FC<React.PropsWithChildren<HTMLAttributes<HTMLHRElement>>> = props => <StyledSeparator {...props} />;

const StyledSeparator = styled.hr`
    background: ${({ theme }) => theme.colors.neutral['20']};
    height: 1px;
    border: none;
    margin: 4rem 0;
`;

export default Separator;
